import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import registry from 'react-mui-lib/registry';


function countDigits(value) {
    return (value || '').replace(/\D/g, '').length;
}


function normalizeDigits(value) {
    let digits = (value || '').replace(/\D/g, '');

    if (digits.length === 0) {
        return '7';
    }

    if (digits.charAt(0) === '8') {
        digits = '7' + digits.slice(1);
    }

    if (!digits.startsWith('7')) {
        digits = '7' + digits;
    }

    if (digits.length > 11) {
        digits = digits.slice(0, 11);
    }

    return digits;
}


function formatFromDigits(digits) {
    if (!digits) {
        return '+7';
    }

    let formatted = '+' + digits.charAt(0);

    if (digits.length > 1) {
        formatted += ' (' + digits.slice(1, Math.min(4, digits.length));
    }

    if (digits.length > 4) {
        formatted += ') ' + digits.slice(4, Math.min(7, digits.length));
    }

    if (digits.length > 7) {
        formatted += '-' + digits.slice(7, Math.min(9, digits.length));
    }

    if (digits.length > 9) {
        formatted += '-' + digits.slice(9, Math.min(11, digits.length));
    }

    return formatted;
}


function formatPhoneWithCaret(value, caret) {
    const rawDigits = (value || '').replace(/\D/g, '');
    const newDigits = normalizeDigits(value);
    const formatted = formatFromDigits(newDigits);

    const oldDigitCountBefore = countDigits(value.slice(0, caret));
    const newCaretDigitCount = Math.min(
        Math.max(oldDigitCountBefore + (newDigits.length - rawDigits.length), 0),
        newDigits.length
    );

    let newCaret = 0;
    let seen = 0;

    if (newCaretDigitCount === 0) {
        newCaret = 0;
    } else {
        for (let i = 0; i < formatted.length; ++i) {
            if (/\d/.test(formatted.charAt(i))) {
                seen += 1;
                if (seen === newCaretDigitCount) {
                    newCaret = i + 1;
                    break;
                }
            }
        }
    }

    return {value: formatted, caret: newCaret};
}


export default class AddParticipantsDialog extends React.Component {
    open() {
        this.setState({
            dialog_open: true,
            phone: '+7',
            error: '',
            loading: false
        });
        this.pendingCaret = 2;
    }

    constructor(props) {
        super(props);

        this.state = {
            dialog_open: false,
            phone: '+7',
            error: '',
            loading: false
        };

        this.participant_controller = registry.get('participant_grid_controller');
        this.game_form_controller = registry.get('game_form_controller');
        this.store = registry.get('store');
        this.unsubscribe_store = null;
        this.input = null;
        this.pendingCaret = null;
    }

    componentDidMount() {
        this.unsubscribe_store = this.store.subscribe(() => {
            if (this.state.dialog_open) {
                this.forceUpdate();
            }
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe_store) {
            this.unsubscribe_store();
        }
    }

    componentDidUpdate() {
        if (this.pendingCaret !== null && this.input) {
            this.input.setSelectionRange(this.pendingCaret, this.pendingCaret);
            this.pendingCaret = null;
        }
    }

    getMaxParticipants() {
        const plan = this.game_form_controller.getModel('plan').getModelValue();
        return plan === 'novice' ? 5 : null;
    }

    getParticipantCount() {
        return (this.participant_controller.state.rows || []).length;
    }

    render() {
        const c = this;
        const maxParticipants = c.getMaxParticipants();
        const participantCount = c.getParticipantCount();
        const isLimitReached = maxParticipants !== null && participantCount >= maxParticipants;
        const currentPhone = normalizeDigits(c.state.phone);
        const isDuplicate = currentPhone.length === 11 && this.participant_controller.isParticipant('+' + currentPhone);
        const limitText = maxParticipants !== null
            ? `Участников: ${participantCount} из ${maxParticipants}`
            : `Участников: ${participantCount}`;

        return <Dialog fullWidth={true}
                       open={c.state.dialog_open}
                       onClose={() => c.close()}>
            <DialogTitle>Добавить участников</DialogTitle>
            <DialogContent>
                <TextField autoFocus
                           fullWidth
                           label="Номер телефона"
                           placeholder="+7 (999) 999-99-99"
                           value={c.state.phone}
                           disabled={c.state.loading || isLimitReached}
                           error={!!c.state.error || isLimitReached || isDuplicate}
                           helperText={c.state.error || (isDuplicate ? 'Участник с таким номером уже добавлен' : (isLimitReached ? 'Достигнут лимит участников для тарифа Новичок' : 'Введите номер телефона зарегистрированного игрока'))}
                           margin="normal"
                           inputRef={el => c.input = el}
                           InputLabelProps={{
                               shrink: true,
                               style: {color: '#0BADEC'}
                           }}
                           InputProps={{
                               style: {fontSize: '1.1rem'}
                           }}
                           onChange={e => c.handleChange(e)}
                           onKeyPress={e => {
                               if (e.key === 'Enter') {
                                   c.addByPhone();
                               }
                           }} />
                <Typography variant="caption" color={isLimitReached ? 'error' : 'inherit'}>
                    {limitText}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button color="primary"
                        disabled={c.state.loading || isLimitReached || isDuplicate || normalizeDigits(c.state.phone).length !== 11}
                        onClick={() => c.addByPhone()}>
                    Добавить
                </Button>
                <Button onClick={() => c.close()}
                        disabled={c.state.loading}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>;
    }

    handleChange(e) {
        const input = e.target;
        const value = input.value;
        const start = input.selectionStart;

        const result = formatPhoneWithCaret(value, start);

        this.pendingCaret = result.caret;
        this.setState({phone: result.value, error: ''});
    }

    addByPhone() {
        const c = this;
        const digits = normalizeDigits(c.state.phone);

        if (digits.length !== 11 || !digits.startsWith('7')) {
            c.setState({error: 'Введите корректный номер телефона'});
            return;
        }

        if (c.participant_controller.isParticipant('+' + digits)) {
            c.setState({error: 'Участник с таким номером уже добавлен'});
            return;
        }

        const maxParticipants = c.getMaxParticipants();
        if (maxParticipants !== null && c.getParticipantCount() >= maxParticipants) {
            c.setState({error: 'Достигнут лимит участников для тарифа Новичок'});
            return;
        }

        c.setState({loading: true, error: ''});

        c.participant_controller.addByPhone('+' + digits)
            .then(() => {
                c.setState({
                    dialog_open: false,
                    phone: '+7',
                    error: '',
                    loading: false
                });
                c.pendingCaret = 2;
                c.participant_controller.load();
            }, error => {
                let message = error.message || 'Ошибка добавления участника';

                if (error.code === 'user-not-found') {
                    message = 'Номер не найден, убедитесь что пользователь зарегистрирован в приложении с этим номером';
                } else if (error.code === 'bad-phone') {
                    message = 'Неправильный номер телефона';
                } else if (error.code === 'participant-limit') {
                    message = 'Для тарифа Новичок можно добавить не более 5 участников';
                }

                c.setState({
                    loading: false,
                    error: message
                });
            });
    }

    close() {
        this.setState({
            dialog_open: false,
            phone: '+7',
            error: '',
            loading: false
        });
        this.pendingCaret = 2;
    }
}
